import { render, staticRenderFns } from "./printing_invoice_settings.vue?vue&type=template&id=19576366"
import script from "./printing_invoice_settings.vue?vue&type=script&lang=js"
export * from "./printing_invoice_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports